import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { z } from "zod"

export const UserDtoSchema = z
  .object({
    id: z.string(),
    username: z.string(),
    firstname: z.string(),
    lastname: z.string(),
    avatar: HUImageDtoSchema.nullable(),
  })
  .meta({ id: "UserDtoSchema" })

export type UserDto = z.infer<typeof UserDtoSchema>
